import React from "react";
import TrackVisibility from "react-on-screen";
import CodeSnippet from "../elements/CodeSnippet";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Jesus",
  avatarImage: "/images/avatar-2.svg",
  content:
    "I am Jesús Nieves, a developer from Venezuela, I currently reside in Buenos Aires - Argentina. I work as an iOS developer, but I always love to go a bit further, before focusing on native development I did a lot of work as a frontend and backend. I also studied graphic design (although I did not finish my degree). I love learning new things and I am obsessed with making things look good.",
};

const progressData = [
  {
    id: 1,
    title: "Software Development",
    percantage: 90,
    progressColor: "#FFD15C",
  },
  {
    id: 2,
    title: "UI/UX Design",
    percantage: 58,
    progressColor: "#FF4C60",
  },
  {
    id: 3,
    title: "Google Searching Skills",
    percantage: 90,
    progressColor: "#28a745",
  },  
  {
    id: 4,
    title: "PlayStation / PC Gaming",
    percantage: 35,
    progressColor: "#6C6CE5",
  },  
  {
    id: 5,
    title: "Netflix, Prime Video, Disney+",
    percantage: 86,
    progressColor: "#03a9f4",
  },    
];

const counterData = [
  {
    id: 1,
    title: "Projects completed",
    count: 112,
    icon: "icon-fire",
  },
  {
    id: 2,
    title: "Songs Played",
    count: 4820,
    icon: "icon-social-spotify",
  },
  {
    id: 3,
    title: "Game finished",
    count: 32,
    icon: "icon-game-controller",
  },
  {
    id: 4,
    title: "TV Series completed",
    count: 87,
    icon: "icon-control-play",
  },
];

function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title={<CodeSnippet text={'// Show this guy (Jesus) basic personal information\nprint(self.about)'} language="swift"/>} />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    <a href="https://gitconnected.com/nievesjesus/resume" rel="noopener noreferrer" target="_blank" className="btn btn-default">
                      Download CV
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
